export default __webpack_public_path__ + "static/media/management-icon.95cd6624.svg";